import { Field, ID, InputType, Int, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('PlantSiloInput')
export class PlantSilo {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  sortIndex?: number

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  summary?: string
}
